import { skills } from '../../../helpers/constants';
import './Skills.scss';
import RenderIf from '../../RenderIf';
import { motion } from 'framer-motion';

type SkillRowProps = { name: string, certified?: boolean };
const SkillRow = ({ name, certified = false }: SkillRowProps): JSX.Element => (
    <>
        <motion.p className="skills-row"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ type: 'tween', duration: 0.6 }}
            onViewportEnter={e => setTimeout(() => (e?.target as HTMLParagraphElement).style.opacity = 'revert-layer', 700)}
        >
            <span>{name}</span>
            <RenderIf condition={certified}>
                <img src="/certified.svg" alt="Certified" title="Certified"></img>
            </RenderIf>
        </motion.p>
        <motion.div className='divider' initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ type: 'tween', duration: 0.6 }}></motion.div>
    </>
)

const Skills = ({ skillsSection }: { skillsSection: React.RefObject<HTMLElement> }): JSX.Element => {
    return (
        <section id="skills" ref={skillsSection}>
            {
                skills.map((e, i) => (
                    <div className="skills-column" key={i}>
                        {
                            Object.entries(e).map(([category, skills], i) => (
                                <div className="skills-section" key={i}>
                                    <motion.h2 initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ type: 'tween', duration: 0.6 }}>{category}</motion.h2>
                                    <div className="skills-rows">
                                        <motion.div className='divider' initial={{ opacity: 0 }} whileInView={{ opacity: 1 }}></motion.div>
                                        {
                                            skills.map((e, i) =>
                                                <SkillRow {...e} key={i} />
                                            )
                                        }
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                ))
            }
        </section>
    );
}

export default Skills;
